import { render, staticRenderFns } from "./WebsitePageSelector.vue?vue&type=template&id=4ede8ddc&scoped=true&"
import script from "./WebsitePageSelector.vue?vue&type=script&lang=js&"
export * from "./WebsitePageSelector.vue?vue&type=script&lang=js&"
import style0 from "./WebsitePageSelector.vue?vue&type=style&index=0&id=4ede8ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede8ddc",
  null
  
)

export default component.exports